import Cookies from 'js-cookie';

import noticeError from './noticeError';


/**
 * If there is a valid referral cookie for the requested BU, return its `aff_id`.
 * If it is not valid (does not start with 'P'), return null.
 *
 * @param {number} referralBU - value from REFERRAL_OFFER_IDS
 * @return {string|null}
 */
function getPersonalReferralIdFromCookie(referralBU) {
    if (!Object.values(REFERRAL_OFFER_IDS).includes(referralBU)) {
        noticeError(`[getPersonalReferralIdFromCookie] - unrecognized business unit: “${referralBU}”`, {
            expectedBUs: JSON.stringify(REFERRAL_OFFER_IDS),
        });

        return null;
    }

    try {
        const referralId = JSON.parse(Cookies.get(`${REFERRAL_COOKIE_BASE}${referralBU}`));

        // as mentioned in https://ratehub.atlassian.net/wiki/spaces/DEV/pages/3230007316/Affiliate+Referral+Attribution+System
        // Profile-level referral IDs all start with the letter 'P'.
        // All site-level affiliate partners (example: MoneySense) have an integer (example: 780).
        // In this case, we’re only interested in the code if it belongs to a profile.
        return referralId?.aff_id?.slice(0, 1) === 'P'
            ? referralId
            : null;
    } catch {
        return null;
    }
}

const REFERRAL_COOKIE_BASE = 'rh-aff-offer-';
const REFERRAL_OFFER_IDS = {
    mortgage: 2,
    creditCard: 4,
    gic: 10,
    savings: 12,
    chequing: 12,
    roboAdvisor: 14,
};


export { REFERRAL_OFFER_IDS };
export default getPersonalReferralIdFromCookie;
